var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { InkyApiV2 } from '../API/InkyApiV2';
import { PaymentMethod } from '../Models/Purchase';
import { PurchaseAttempt } from '../Models/PurchaseAttempt';
import { CartIdAtom, FetchCartAtom } from './CartStore';
import { v4 as uuid } from 'uuid';
import { PurchaseError } from '../Models/Errors/PurchaseError';
// PaymentProcessingOverlay
export var ShowPaymentProcessingOverlayAtom = atom(false);
export var PaymentMethodAtom = atomWithStorage('paymentMethod', PaymentMethod.NotSelected);
export var PaymentIntentAtom = atomWithStorage('paymentIntent', false);
export var SuccessOrderIDAtom = atom('');
export var IsPurchaseCompleteAtom = atom(false);
export var LastPurchaseIdAtom = atom(-1);
export var PaymentPurchaseAtom = atom(false);
export var FetchPaymentPurchaseAtom = atom(function (get) { return get(PaymentPurchaseAtom); }, function (get, set) { return __awaiter(void 0, void 0, void 0, function () {
    var paymentIntent, purchase;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                paymentIntent = get(PaymentIntentAtom);
                if (!paymentIntent)
                    return [2 /*return*/];
                return [4 /*yield*/, InkyApiV2.shared().FetchPurchaseByPaymentIntent(paymentIntent)];
            case 1:
                purchase = _a.sent();
                set(PaymentPurchaseAtom, purchase);
                return [2 /*return*/];
        }
    });
}); });
export var PaymentConfirmationStatus;
(function (PaymentConfirmationStatus) {
    PaymentConfirmationStatus[PaymentConfirmationStatus["Ready"] = 0] = "Ready";
    PaymentConfirmationStatus[PaymentConfirmationStatus["Processing"] = 1] = "Processing";
    PaymentConfirmationStatus[PaymentConfirmationStatus["Successful"] = 2] = "Successful";
    PaymentConfirmationStatus[PaymentConfirmationStatus["ApiError"] = 3] = "ApiError";
    PaymentConfirmationStatus[PaymentConfirmationStatus["CardError"] = 4] = "CardError";
    PaymentConfirmationStatus[PaymentConfirmationStatus["IdempotencyError"] = 5] = "IdempotencyError";
    PaymentConfirmationStatus[PaymentConfirmationStatus["InvalidRequestError"] = 6] = "InvalidRequestError";
    PaymentConfirmationStatus[PaymentConfirmationStatus["InternalError"] = 7] = "InternalError";
})(PaymentConfirmationStatus || (PaymentConfirmationStatus = {}));
// Atoms for Stripe Card events
export var StripeCardElementAtom = atom(false);
export var StripePaymentRequestAtom = atom(false);
export var StripeObjectAtom = atom(false);
export var StripeConfirmPaymentStatusAtom = atom(PaymentConfirmationStatus.Ready);
export var StripeConfirmPaymentAtom = atom(function (get) { return get(StripeConfirmPaymentStatusAtom); }, function (get, set, pa) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/];
    });
}); });
// Initiate Purchase Stores
export var PurchaseAttemptAtom = atom(null);
// region Error-Handling
// region Primary Error-Handler
export var PurchaseErrorType;
(function (PurchaseErrorType) {
    PurchaseErrorType[PurchaseErrorType["NoError"] = 0] = "NoError";
    PurchaseErrorType[PurchaseErrorType["InvalidPaymentMethodError"] = 1] = "InvalidPaymentMethodError";
})(PurchaseErrorType || (PurchaseErrorType = {}));
var PrimaryErrorHandlerAtom = atom(PurchaseErrorType.NoError);
// endregion Primary Error-Handler
// region StripeCardDetail Error-handler
export var StripeCardDetailErrorType;
(function (StripeCardDetailErrorType) {
    StripeCardDetailErrorType[StripeCardDetailErrorType["NoError"] = 0] = "NoError";
    StripeCardDetailErrorType[StripeCardDetailErrorType["InvalidCardNumber"] = 1] = "InvalidCardNumber";
    StripeCardDetailErrorType[StripeCardDetailErrorType["InvalidExpirationDate"] = 2] = "InvalidExpirationDate";
    StripeCardDetailErrorType[StripeCardDetailErrorType["InvalidCCVNumber"] = 3] = "InvalidCCVNumber";
})(StripeCardDetailErrorType || (StripeCardDetailErrorType = {}));
var StripeCardDetailsErrorHandlerAtom = atom(StripeCardDetailErrorType.NoError);
// endregion StripeCardDetail Error-handler
// endregion Error-Handling
export var PurchaseErrorMessage;
(function (PurchaseErrorMessage) {
    PurchaseErrorMessage[PurchaseErrorMessage["NoError"] = 0] = "NoError";
    PurchaseErrorMessage[PurchaseErrorMessage["InvalidStripePaymentCredentials"] = 1] = "InvalidStripePaymentCredentials";
})(PurchaseErrorMessage || (PurchaseErrorMessage = {}));
export var StripeCardErrorMessage;
(function (StripeCardErrorMessage) {
    StripeCardErrorMessage[StripeCardErrorMessage["IsValid"] = 0] = "IsValid";
    StripeCardErrorMessage[StripeCardErrorMessage["StripeCardInvalidCardNumber"] = 1] = "StripeCardInvalidCardNumber";
    StripeCardErrorMessage[StripeCardErrorMessage["StripeCardInvalidExpirationDate"] = 2] = "StripeCardInvalidExpirationDate";
    StripeCardErrorMessage[StripeCardErrorMessage["StripeCardInvalidCCVNumber"] = 3] = "StripeCardInvalidCCVNumber";
})(StripeCardErrorMessage || (StripeCardErrorMessage = {}));
export var StripeProcessingErrorMessage;
(function (StripeProcessingErrorMessage) {
    StripeProcessingErrorMessage[StripeProcessingErrorMessage["NoError"] = 0] = "NoError";
    StripeProcessingErrorMessage[StripeProcessingErrorMessage["UnknownError"] = 1] = "UnknownError";
    StripeProcessingErrorMessage[StripeProcessingErrorMessage["ApiConnectionError"] = 2] = "ApiConnectionError";
    StripeProcessingErrorMessage[StripeProcessingErrorMessage["ApiError"] = 3] = "ApiError";
    StripeProcessingErrorMessage[StripeProcessingErrorMessage["ApiAuthError"] = 4] = "ApiAuthError";
    StripeProcessingErrorMessage[StripeProcessingErrorMessage["CardError"] = 5] = "CardError";
    StripeProcessingErrorMessage[StripeProcessingErrorMessage["IdempotencyError"] = 6] = "IdempotencyError";
    StripeProcessingErrorMessage[StripeProcessingErrorMessage["InvalidRequestError"] = 7] = "InvalidRequestError";
    StripeProcessingErrorMessage[StripeProcessingErrorMessage["RateLimitError"] = 8] = "RateLimitError";
    StripeProcessingErrorMessage[StripeProcessingErrorMessage["ValidationError"] = 9] = "ValidationError";
})(StripeProcessingErrorMessage || (StripeProcessingErrorMessage = {}));
export var PurchaseValidationError;
(function (PurchaseValidationError) {
    PurchaseValidationError[PurchaseValidationError["NoError"] = 0] = "NoError";
    PurchaseValidationError[PurchaseValidationError["UnknownError"] = 1] = "UnknownError";
    PurchaseValidationError[PurchaseValidationError["TaxError"] = 2] = "TaxError";
})(PurchaseValidationError || (PurchaseValidationError = {}));
// This is the Primary error-handler. Sub-handlers should set and reset this.
// Stripe Card-info valudation error-handler
export var StripeCardInfoErrorHandlerAtom = atom(StripeCardErrorMessage.IsValid);
export var StripePaymentProcessingErrorHandlerAtom = atom(StripeProcessingErrorMessage.NoError);
export var PurchaseValidationErrorHandlerAtom = atom(PurchaseValidationError.NoError);
export var ShowCheckoutErrorMessages = atom(false);
export var InitiatePurchaseAtom = atom(function (get) { return get(PurchaseAttemptAtom); }, function (get, set, props) { return __awaiter(void 0, void 0, void 0, function () {
    var pMethod, stripePaymentInfoIsValid, cart, freeOrder, purchaseAttempt, createdPurchase;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                pMethod = get(PaymentMethodAtom);
                stripePaymentInfoIsValid = get(StripeCardInfoErrorHandlerAtom);
                cart = get(FetchCartAtom);
                freeOrder = cart && cart.isFreeOrder();
                set(ShowCheckoutErrorMessages, false);
                console.log('Initiating purchase');
                console.log(pMethod);
                if (freeOrder && pMethod != PaymentMethod.NotSelected) {
                    console.log('Free order detected and payment method is not none. Correcting to none');
                    pMethod = PaymentMethod.NotSelected;
                    set(PaymentMethodAtom, pMethod);
                }
                if (!pMethod && !freeOrder)
                    return [2 /*return*/]; // TODO: Add error handling here?
                console.log('Initiating Purchase Request');
                // Pre-Checks for Stripe (Card)
                if (pMethod == PaymentMethod.Card) {
                    // Pre-Check the card details are valid.
                    if (stripePaymentInfoIsValid !== StripeCardErrorMessage.IsValid) {
                        console.error('Payment-info is not valid!', stripePaymentInfoIsValid);
                        set(ShowCheckoutErrorMessages, true);
                        return [2 /*return*/];
                    }
                }
                purchaseAttempt = new PurchaseAttempt();
                purchaseAttempt.purchase = props.pr;
                purchaseAttempt.purchase.paymentMethod = pMethod;
                // Create the purchase in the backend.
                purchaseAttempt.onPurchaseRejected = function (purchase, message) {
                    console.warn('Purchase Failed for reason: ', message);
                    console.warn(purchase);
                    if (message == "Could not calculate tax") {
                        set(PurchaseValidationErrorHandlerAtom, PurchaseValidationError.TaxError);
                    }
                    set(ShowCheckoutErrorMessages, true);
                    return;
                };
                // Reset before we recheck
                set(PurchaseValidationErrorHandlerAtom, PurchaseValidationError.NoError);
                return [4 /*yield*/, purchaseAttempt.createPurchase()];
            case 1:
                createdPurchase = _a.sent();
                if (!createdPurchase) return [3 /*break*/, 3];
                // Define the executePayment-callback based on what payment-method was chosen.
                switch (pMethod) {
                    case PaymentMethod.Card:
                        createdPurchase.executePayment = function (purchase) { return __awaiter(void 0, void 0, void 0, function () {
                            var stripeObject, cardElement, paymentIntentSecret, _a, paymentIntent, error;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        console.log('Paying for Purchase');
                                        set(StripeConfirmPaymentStatusAtom, PaymentConfirmationStatus.Processing);
                                        // Hide Error Messages for now
                                        set(ShowCheckoutErrorMessages, false);
                                        // Reset Stripe Payent Error
                                        set(StripePaymentProcessingErrorHandlerAtom, StripeProcessingErrorMessage.NoError);
                                        console.log('Processing Purchase atom');
                                        stripeObject = get(StripeObjectAtom);
                                        cardElement = get(StripeCardElementAtom);
                                        paymentIntentSecret = purchase.paymentIntent;
                                        if (cardElement == false) {
                                            console.error('Card-element not found. Cancelling');
                                            set(StripeConfirmPaymentStatusAtom, PaymentConfirmationStatus.InternalError);
                                            return [2 /*return*/];
                                        }
                                        if (!stripeObject) {
                                            console.error('Stripe Object not loaded for atom.');
                                            set(StripeConfirmPaymentStatusAtom, PaymentConfirmationStatus.InternalError);
                                            return [2 /*return*/];
                                        }
                                        if (!paymentIntentSecret) {
                                            console.error('Payment Intent not found.');
                                            set(StripeConfirmPaymentStatusAtom, PaymentConfirmationStatus.InternalError);
                                            return [2 /*return*/];
                                        }
                                        console.log("Sending request to stripe to charge the card.");
                                        return [4 /*yield*/, stripeObject.confirmCardPayment(paymentIntentSecret, 
                                            // eslint-disable-next-line @typescript-eslint/camelcase
                                            { payment_method: { card: cardElement } })];
                                    case 1:
                                        _a = _b.sent(), paymentIntent = _a.paymentIntent, error = _a.error;
                                        console.log('STRIPE CONFIRM', paymentIntent);
                                        console.log('Stripe error?', error);
                                        if (error) {
                                            // TODO: Iterate trough errors and set the status-atom accordingly
                                            switch (error.type) {
                                                case 'api_connection_error':
                                                    set(StripePaymentProcessingErrorHandlerAtom, StripeProcessingErrorMessage.ApiConnectionError);
                                                    throw new PurchaseError("Could not connect to Stripe", purchase);
                                                case 'api_error':
                                                    set(StripePaymentProcessingErrorHandlerAtom, StripeProcessingErrorMessage.ApiError);
                                                    throw new PurchaseError("Could not communicate with Stripe", purchase);
                                                case 'authentication_error':
                                                    set(StripePaymentProcessingErrorHandlerAtom, StripeProcessingErrorMessage.ApiAuthError);
                                                    throw new PurchaseError("Could not make a secure connection with Stripe", purchase);
                                                case 'card_error':
                                                    set(StripePaymentProcessingErrorHandlerAtom, StripeProcessingErrorMessage.CardError);
                                                    throw new PurchaseError("There was an error with the card", purchase);
                                                case 'idempotency_error':
                                                    set(StripePaymentProcessingErrorHandlerAtom, StripeProcessingErrorMessage.IdempotencyError);
                                                    throw new PurchaseError("There was a communication error with Stripe", purchase);
                                                case 'invalid_request_error':
                                                    set(StripePaymentProcessingErrorHandlerAtom, StripeProcessingErrorMessage.InvalidRequestError);
                                                    throw new PurchaseError("Stripe could not understand the request", purchase);
                                                case 'rate_limit_error':
                                                    set(StripePaymentProcessingErrorHandlerAtom, StripeProcessingErrorMessage.RateLimitError);
                                                    throw new PurchaseError("Stripe rejected the request (Rate-limited)", purchase);
                                                case 'validation_error':
                                                    set(StripePaymentProcessingErrorHandlerAtom, StripeProcessingErrorMessage.ValidationError);
                                                    throw new PurchaseError("Could not validate the card", purchase);
                                                default:
                                                    set(StripePaymentProcessingErrorHandlerAtom, StripeProcessingErrorMessage.UnknownError);
                                                    throw new PurchaseError("Stripe Charge failed for non-known reason.", purchase);
                                            }
                                        }
                                        else {
                                            // Order is hereby client confirmed.
                                            return [2 /*return*/, {
                                                    message: 'Payment Successfull',
                                                    transactionId: paymentIntent.id,
                                                    purchase: purchase,
                                                }];
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); };
                        break;
                    case PaymentMethod.Paypal:
                        createdPurchase.executePayment = function (purchase) { return __awaiter(void 0, void 0, void 0, function () {
                            var paymentIntent;
                            return __generator(this, function (_a) {
                                paymentIntent = purchase.paymentIntent;
                                if (!paymentIntent) {
                                    console.error('Payment Intent not found.');
                                    set(StripeConfirmPaymentStatusAtom, PaymentConfirmationStatus.InternalError);
                                    return [2 /*return*/];
                                }
                                set(PaymentIntentAtom, purchase.paymentIntent);
                                // Redirect (window.location usage intended) to paypal
                                window.location.href = process.env.REACT_APP_PAYPAL_APPROVE_URL + '?token=' + purchase.paymentIntent;
                                return [2 /*return*/];
                            });
                        }); };
                        break;
                    case PaymentMethod.GooglePay:
                    case PaymentMethod.ApplePay:
                        createdPurchase.executePayment = function (purchase) { return __awaiter(void 0, void 0, void 0, function () {
                            var stripeObject, paymentIntentSecret, paymentRequest, paymentMethodEv, _a, paymentIntent, confirmError, error;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        console.log('Paying for Purchase Trough Webpay');
                                        set(StripeConfirmPaymentStatusAtom, PaymentConfirmationStatus.Processing);
                                        console.log('Processing Purchase atom');
                                        stripeObject = get(StripeObjectAtom);
                                        paymentIntentSecret = purchase.paymentIntent;
                                        paymentRequest = get(StripePaymentRequestAtom);
                                        paymentMethodEv = props.webpayPaymentEvent;
                                        if (!stripeObject) {
                                            console.error('Stripe Object not loaded for atom.');
                                            set(StripeConfirmPaymentStatusAtom, PaymentConfirmationStatus.InternalError);
                                            return [2 /*return*/];
                                        }
                                        if (!paymentIntentSecret) {
                                            console.error('Payment Intent not found.');
                                            set(StripeConfirmPaymentStatusAtom, PaymentConfirmationStatus.InternalError);
                                            return [2 /*return*/];
                                        }
                                        if (!paymentRequest) {
                                            console.error('Payment Request not found.');
                                            set(StripeConfirmPaymentStatusAtom, PaymentConfirmationStatus.InternalError);
                                            return [2 /*return*/];
                                        }
                                        if (!paymentMethodEv) {
                                            console.error('Payment-method not received from webPayment.');
                                            set(StripeConfirmPaymentStatusAtom, PaymentConfirmationStatus.InternalError);
                                            return [2 /*return*/];
                                        }
                                        return [4 /*yield*/, stripeObject.confirmCardPayment(paymentIntentSecret, 
                                            // eslint-disable-next-line @typescript-eslint/camelcase
                                            { payment_method: paymentMethodEv.paymentMethod.id }, { handleActions: false })];
                                    case 1:
                                        _a = _b.sent(), paymentIntent = _a.paymentIntent, confirmError = _a.error;
                                        if (!confirmError) return [3 /*break*/, 2];
                                        paymentMethodEv.complete('fail');
                                        // TODO: Iterate trough errors and set the status-atom accordingly
                                        switch (confirmError.type) {
                                            case 'api_connection_error':
                                                set(StripeConfirmPaymentStatusAtom, PaymentConfirmationStatus.InternalError);
                                                break;
                                            case 'api_error':
                                                set(StripeConfirmPaymentStatusAtom, PaymentConfirmationStatus.ApiError);
                                                break;
                                            case 'authentication_error':
                                                set(StripeConfirmPaymentStatusAtom, PaymentConfirmationStatus.InternalError);
                                                break;
                                            case 'card_error':
                                                set(StripeConfirmPaymentStatusAtom, PaymentConfirmationStatus.CardError);
                                                break;
                                            case 'idempotency_error':
                                                set(StripeConfirmPaymentStatusAtom, PaymentConfirmationStatus.InternalError);
                                                break;
                                            case 'invalid_request_error':
                                                set(StripeConfirmPaymentStatusAtom, PaymentConfirmationStatus.InvalidRequestError);
                                                break;
                                            case 'rate_limit_error':
                                                set(StripeConfirmPaymentStatusAtom, PaymentConfirmationStatus.InternalError);
                                                break;
                                            case 'validation_error':
                                                set(StripeConfirmPaymentStatusAtom, PaymentConfirmationStatus.CardError);
                                                break;
                                        }
                                        return [3 /*break*/, 5];
                                    case 2:
                                        console.log('STRIPE CONFIRM', paymentIntent);
                                        if (!(paymentIntent.status === "requires_action")) return [3 /*break*/, 4];
                                        return [4 /*yield*/, stripeObject.confirmCardPayment(paymentIntentSecret)];
                                    case 3:
                                        error = (_b.sent()).error;
                                        if (error) {
                                            // The payment failed -- ask your customer for a new payment method.
                                            console.error("Something failed. add error handling.", error);
                                            return [2 /*return*/];
                                        }
                                        else {
                                            // The payment has succeeded.
                                            return [2 /*return*/, {
                                                    message: 'Payment Successful',
                                                    transactionId: paymentIntent.id,
                                                    purchase: purchase,
                                                }];
                                        }
                                        _b.label = 4;
                                    case 4:
                                        paymentMethodEv.complete('success');
                                        return [2 /*return*/, {
                                                message: 'Payment Successful',
                                                transactionId: paymentIntent.id,
                                                purchase: purchase,
                                            }];
                                    case 5: return [2 /*return*/];
                                }
                            });
                        }); };
                        break;
                    default:
                        if (createdPurchase.purchase.totalPrice.getAmount() == 0) {
                            createdPurchase.executePayment = function (purchase) { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    return [2 /*return*/, {
                                            message: 'Free Order No Payment Required',
                                            transactionId: 'FreeOrder',
                                            purchase: purchase,
                                        }];
                                });
                            }); };
                        }
                        else {
                            throw new Error('Payment method not implemented');
                        }
                }
                createdPurchase.onPurchaseSuccessful = function (purchase, message) {
                    console.log('Purchase was finalized and payment confirmed by Client.', message);
                    console.log(purchase);
                    // TODO: Add overlay for ordercomplete
                    // Hide checkout
                    // Reset Cart id
                    set(CartIdAtom, uuid());
                    // Hide Processing
                    // Show Ordercomplete overlay
                    set(LastPurchaseIdAtom, purchase.id);
                    set(IsPurchaseCompleteAtom, true);
                    //KlaviyoManager.PurchaseEvent(purchase);
                };
                return [4 /*yield*/, createdPurchase.payForPurchase()];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}); });
export var IsInitiatingPurchaseAtom = atom(false);
export var LoadableInitiatePurchaseAtom = atom(function (get) { return get(InitiatePurchaseAtom); }, function (get, set, props) { return __awaiter(void 0, void 0, void 0, function () {
    var e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                set(IsInitiatingPurchaseAtom, true);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, 4, 5]);
                return [4 /*yield*/, set(InitiatePurchaseAtom, props)];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_1 = _a.sent();
                console.error(e_1);
                return [3 /*break*/, 5];
            case 4:
                set(IsInitiatingPurchaseAtom, false);
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); });
export var ShippingAddressValidationResponseAtom = atom(false);
export var ShippingAddressValidationResponseIsValidAddressAtom = atom(function (get) {
    var response = get(ShippingAddressValidationResponseAtom);
    if (response === false || response === null || response === undefined)
        return false;
    if (!response.result.verdict.addressComplete) {
        console.log('YEEEEDAD Address is not complete');
        return false;
    }
    switch (response.result.verdict.validationGranularity) {
        case 'Premise':
        case 'SubPremise':
            // continue
            break;
        default:
            console.log('YEEEEDAD Address is not granular enough');
            return false;
    }
    var hasInferredComponents = false;
    var hasSpellCorrectedComponents = false;
    var country = '';
    response.result.address.addressComponents.forEach(function (component) {
        if (component.inferred && component.componentType !== 'postal_code_suffix') {
            hasInferredComponents = true;
        }
        if (component.spellCorrected) {
            hasSpellCorrectedComponents = true;
        }
        if (component.componentType === 'country') {
            country = component.componentName.text;
        }
    });
    if (country === "USA") {
        switch (response.result.uspsData.dpvConfirmation) {
            case 'Y':
                break;
            default:
                console.log('YEEEEDAD Address is not DPV confirmed for USA');
                return false;
        }
    }
    if (hasInferredComponents) {
        console.log('YEEEEDAD3 Address has inferred components');
        return false;
    }
    if (hasSpellCorrectedComponents) {
        console.log('YEEEEDAD3 Address  has SpellCorrectedComponents components');
        return false;
    }
    if (response.result.verdict.hasReplaceableComponents) {
        console.log('YEEEEDAD Address has replaceable components');
        return false;
    }
    return true;
});
export var ShippingAddressValidationResponseNeedConfirmationAtom = atom(function (get) {
    var response = get(ShippingAddressValidationResponseAtom);
    if (response === false || response === null || response === undefined)
        return false;
    if (!response.result.verdict.addressComplete) {
        console.log('YEEEEMOM Address is not complete');
        return false;
    }
    switch (response.result.verdict.validationGranularity) {
        case 'SubPremise':
        case 'Premise':
        case 'PremiseProximity':
        case 'Block':
        case 'Route':
            //continue
            break;
        case "Other":
        case "GranularityUnspecified":
        default:
            console.log('YEEEEMOM Address is not granular enough');
            return false;
    }
    var hasInferredComponents = false;
    var hasSpellCorrectedComponents = false;
    var hasReplaceableComponents = false;
    var country = '';
    response.result.address.addressComponents.forEach(function (component) {
        if (component.inferred && component.componentType !== 'postal_code_suffix') {
            hasInferredComponents = true;
        }
        if (component.spellCorrected) {
            hasSpellCorrectedComponents = true;
        }
        if (component.componentType === 'country') {
            country = component.componentName.text;
        }
        if (component.replaced) {
            hasReplaceableComponents = true;
        }
    });
    if (hasInferredComponents || hasReplaceableComponents) {
        console.log('YEEEEMOM Address is not inferred or replaceable');
        return false;
    }
    if (country === 'USA') {
        switch (response.result.uspsData.dpvConfirmation) {
            case 'Y':
            case 'S':
                break;
            default:
                console.log('YEEEEMOM Address is not DPV confirmed for USA');
                return false;
        }
    }
    return true;
});
export var ShippingVerificationIssuesAtom = atom(function (get) {
    var response = get(ShippingAddressValidationResponseAtom);
    if (response === false || response === null || response === undefined)
        return [];
    var issues = [];
    var country = '';
    response.result.address.addressComponents.forEach(function (component) {
        if (component.inferred && component.componentType !== 'postal_code_suffix') {
            issues.push({ type: 'inferred', label: component.componentType, content: component.componentName.text });
        }
        if (component.spellCorrected) {
            switch (component.componentType) {
                case "route":
                    issues.push({ type: 'spellCorrected', label: component.componentType, content: component.componentName.text });
                    break;
                default:
                    issues.push({ type: 'spellCorrected', label: component.componentType, content: component.componentName.text });
                    break;
            }
        }
        if (component.componentType === 'country') {
            country = component.componentName.text;
        }
    });
    if (country === 'USA') {
        switch (response.result.uspsData.dpvConfirmation) {
            case 'Y':
                break;
            case 'S':
                issues.push({ type: 'dpv', label: 'dpv', content: 'Additional details for this address, such as the apartment, suite, or floor number, have not been confirmed by the USPS. Please verify that all entered information is correct.' });
                break;
            case "D":
                //fix the address
                issues.push({ type: 'dpv', label: 'dpv', content: 'The address is missing secondary information, such as an apartment or suite number. This is recommended for your address.' });
                break;
            case 'N':
            case '':
                issues.push({ type: 'dpv', label: 'dpv', content: 'This address has not been confirmed by the USPS.' });
                break;
            default:
                break;
        }
    }
    return issues;
});
export var ShippingAddressValidationNeedsDPVConfirmAtom = atom(function (get) {
    var response = get(ShippingAddressValidationResponseAtom);
    if (response === false || response === null || response === undefined)
        return false;
    var country = '';
    response.result.address.addressComponents.forEach(function (component) {
        if (component.componentType === 'country') {
            country = component.componentName.text;
        }
    });
    if (country === 'USA') {
        switch (response.result.uspsData.dpvConfirmation) {
            case 'S':
                return true;
            default:
                return false;
        }
    }
});
